module.exports = __webpack_public_path__ + "static/claim@2x.8218f5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fit/fit_sales/claim@2x.png
// module id = 843
// module chunks = 27253921027855